import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import * as Hammer from 'hammerjs';
import {ComputedOptions} from "~knockout/index";
import {getPrimaryScreenVisibilityOptions} from "../ScreenVisibility";
import {Screen} from "../Screen";
import {showPrimaryScreen} from "../ScreenManager";
import {Observable} from '~knockout/index';
import {playSound} from '../../game/audio/AudioManager';

var template = require('./InstructionsScreen.html');

class InstructionsScreenComponent extends Screen
{
    activeSlide: Observable<number>;
    hammerManager: HammerManager;

    /**
     * create knockout bindings
     */
    createBindings()
    {
        //  create super-class bindings

        super.createBindings();

        //  create game-specific bindings

        this.activeSlide = ko.observable(0);

        //  create a new hammer instance

        this.hammerManager = new Hammer(document.body);
    }


    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getPrimaryScreenVisibilityOptions('instructions');
    }


    /**
     * call a function when we show
     */
    onShow()
    {

        this.hammerManager.on('swipe', this.onSwipe);
    }

    /**
     * remove listeners when we hide the screen
     */
    onHide()
    {
        this.hammerManager.off('swipe', this.onSwipe);
    }


    /**
     * when the user swipes, check the direction
     * @param event
     */
    onSwipe = (event: any) =>
    {
        event.velocityX > 0 ? this.previousSlide() : this.nextSlide();
    };


    /**
     * go back to the main menu
     */
    showMainMenu()
    {
        showPrimaryScreen('main-menu');
    }


    /**
     * show the previous slide
     */
    previousSlide()
    {
        var newSlide: number;

        //  increment slide index

        newSlide = Math.max(0, this.activeSlide() - 1);

        //  set observable value

        this.activeSlide(newSlide);
    }


    /**
     * show the next slide
     */
    nextSlide()
    {
        var newSlide: number;

        //  increment slide index

        newSlide = Math.min(3, this.activeSlide() + 1);

        //  set observable value

        this.activeSlide(newSlide);
    }


    /**
     * start the game; this button is only shown on the last slide
     */
    startGame = () =>
    {
        showPrimaryScreen('gameplay');

        //  play a button sound

        playSound('button-click');
    }
}


/**
 * register this component with knockout
 * @param vizID
 */
export function registerInstructionsScreenComponent()
{
    ko.components.register('pp-instructions',
        {
            viewModel: () => { return new InstructionsScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/instructions/InstructionsScreen.ts